import React, { useState, useEffect, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import FallbackSpinner from './components/FallbackSpinner';
import NavBarWithRouter from './components/NavBar';
import Home from './components/Home';
import endpoints from './constants/endpoints';
import NuovaPagina from './components/NuovaPagina';
import Error from './components/Error';

function MainApp() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(endpoints.routes, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => err);
  }, []);

  let dynamicRoutes = null;

  if (data) {
    dynamicRoutes = data.sections.map((route) => {
      const SectionComponent = React.lazy(() => import('./components/' + route.component));
      return (
        <Route
          key={route.headerTitle}
          path={route.path}
          component={() => (
            <SectionComponent header={route.headerTitle} />
          )}
        />
      );
    });
  }

  return (
    <div className="MainApp">
      <NavBarWithRouter />
      <main className="main">
        <Suspense fallback={<FallbackSpinner />}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/nuova-pagina" component={NuovaPagina} />
            {dynamicRoutes}
            <Route path="/*" component={Error} />
          </Switch>
        </Suspense>
      </main>
    </div>
  );
}

export default MainApp;
